<div class="stapel">
  <!-- Allgemeine Benutzerdaten -->
  <section class="karte"
           [class.karte--offen]="!user.emailConfirmed"
           [class.karte--fertig]="user.emailConfirmed">
    <button type="button" class="karte__kopf"
            [attr.aria-expanded]="benutzerdatenExpanded"
            (click)="benutzerdatenExpanded = !benutzerdatenExpanded">
      <mat-icon class="karte__zeichen">
        {{ user.emailConfirmed ? 'check_circle' : 'error_outline' }}
      </mat-icon>
      <span class="karte__titel">Allgemeine Benutzerdaten</span>

      @if (!user.emailConfirmed) {
        <span class="stand stand--offen">Bitte ergänzen</span>
      }

      <mat-icon class="karte__pfeil">expand_more</mat-icon>
    </button>

    @if (benutzerdatenExpanded) {
      <div class="karte__inhalt">
        <form [formGroup]="userMainForm" novalidate class="formular formular--benutzer">
          <mat-form-field appearance="outline" class="mfeld mfeld--fest">
            <mat-label>E-Mail</mat-label>
            <input matInput formControlName="email" />
            <mat-icon matPrefix>mail_outline</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="mfeld">
            <mat-label>Telefonnummer (optional)</mat-label>
            <input matInput type="tel" formControlName="phoneNumber" maxlength="50" />
            <mat-icon matPrefix>call</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="mfeld"
                          [class.mfeld--fehlt]="!userMainForm.controls['firstName'].value">
            <mat-label>Vorname</mat-label>
            <input matInput formControlName="firstName" />
            <mat-icon matPrefix>person</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="mfeld"
                          [class.mfeld--fehlt]="!userMainForm.controls['lastName'].value">
            <mat-label>Nachname</mat-label>
            <input matInput formControlName="lastName" />
            <mat-icon matPrefix>person</mat-icon>
          </mat-form-field>
        </form>

        @if (userMainForm.invalid || !benutzerdatenGespeichert) {
          <footer class="karte__fuss">
            @if (userMainForm.invalid) {
              <span class="karte__text">Vorname und Nachname werden benötigt.</span>
            }
            <button type="button" class="knopf knopf--voll" [disabled]="userMainForm.invalid" (click)="confirm()">
              <mat-icon>check</mat-icon>
              <span>Speichern</span>
            </button>
          </footer>
        }
      </div>
    }
  </section>

  <!-- Mandanten des Benutzers -->
  <div class="gruppe gruppe--profil">
    <span class="gruppe__name">Mandanten</span>
  </div>

  @for (userTenant of userTenants; track userTenant) {
    <confirm-tenant-user [userTenant] = "userTenant" [baseUser] = "user" [stayExpanded] = "userTenant.isExpanded" (onChangeTenantUser)="onChange(user)"></confirm-tenant-user>
  }
</div>
